import SchenckScreen1D from './SchenckScreen1D.png';
import SchenckScreen2D from './SchenckScreen2D.png';

export const getImageSchenckScreen = (nbrOfDecks: number) => {
  if (nbrOfDecks === 2) {
    return SchenckScreen2D;
  } else {
    return SchenckScreen1D;
  }
};
